<template>
  <div class="card">
    <div class="card-header bg-transparent">
      <div class="row align-items-center">
          <div class="col orange">
            <h3><i class="fas fa-box"></i>Bid Quantity</h3>
          </div>
      </div>
    </div>
    <div class="card-body">
      <div class="input-group mb-4">
          <label 
            for="inputEmail3" 
            class="col-form-label">
            Max. # Of Cusip <i class="fas fa-info-circle info" data-toggle="tooltip" title="Maximum number of different Cusip allowed for a trader to bid"></i>
          </label>
          <input :disabled="true"  type="number" class="form-control" placeholder="Max Qty" v-model="maxCusips">
      </div>
      <div class="input-group mb-4">
          <label 
            for="inputEmail3" 
            class="col-form-label">
             Max. Par Value/Cusip <i class="fas fa-info-circle info" data-toggle="tooltip" title="Maximum quantity of a Cusip allowed for a trader to bid"></i>
          </label>
          <input :disabled="true"  type="text" class="form-control" placeholder="Max  Par Value:  /Cusip" v-model="maxParValue">

      </div>
    </div>
</div>
</template>
<script>
export default {
  name: "setbidquantity",
  props: ["bidSettings"],
  watch: {
    $props: {
      handler: function() {
        this.maxCusips = this.bidSettings.maxCusips;
        this.maxParValue = this.bidSettings.maxParValue + "";
      },
      deep: true
    },
    maxParValue: function(newValue) {
      const result = newValue.replace(/\D/g, "")
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      this.$nextTick(() => this.maxParValue = result);
    }
  },
  data() {
    return {
      accessToken:null,
      maxCusips : 0,
      maxParValue : 0,
    };
  },
  methods: {
    navigateListPage(){
      window.location.href = "/bidside/admin-setqtycapital";
    }
  },
  mounted() {
    this.$cognitoAuth.getIdToken((err, result) => {
      if (err) {
        console.log("accessToken is not found", err);
      } else {
        this.accessToken = result;
      }
    }); 
  }
};
</script>